import sortBy from 'lodash/sortBy'
import type { HaulerTemplateFieldDefinition } from './HaulerTemplateDefinition'
import { isSignatureField } from './signatureFieldKeys'

/**
 * Orders fields by `order`, with signature fields (`isSignatureField`) forced after every other
 * field whatever their stored `order`. Returns a new array — the input is never mutated.
 */
export const sortTemplateFields = (fields: HaulerTemplateFieldDefinition[]): HaulerTemplateFieldDefinition[] =>
  sortBy(fields, [(f) => isSignatureField(f.key), 'order'])
